export default __webpack_public_path__ + "static/epilogue-483d9fc13120806e0351d1ae8415d271.svg";